import { useSelector } from 'react-redux';

const useIsDocumentOwner = () => {
  const { roles } = useSelector((state) => state.documentManagementStore);
  const { currentIdentity } = useSelector((state) => state.identityStore);

  return roles?.holder?.includes(currentIdentity.identity.identityId) || false;
};

export default useIsDocumentOwner;
